module.exports = __webpack_public_path__ + "img/smlouvy.df4ef282.svg";